import { heroStats } from '@/mocks/home';

export default function Hero() {
  return (
    <section className="relative">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20editorial%20investigative%20archive%20montage%20of%20scattered%20case%20documents%20on%20a%20wooden%20desk%2C%20red%20redaction%20stamps%20and%20torn%20paper%20edges%2C%20warm%20amber%20desk%20lamp%20light%20cutting%20through%20shadow%2C%20moody%20documentary%20photojournalism%20with%20crimson%20and%20gold%20tones%2C%20heavy%20film%20grain%2C%20high%20contrast%2C%20cinematic%20dark%20composition%2C%20mysterious%20intense%20atmosphere%20without%20blue%20or%20purple&width=1600&height=900&seq=hero-jiuse-2026&orientation=landscape"
          alt="九色黑料专题档案主视觉"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/60 to-foreground-950/90" />
      </div>

      <div className="relative mx-auto flex w-full max-w-6xl flex-col items-center px-4 pb-8 pt-16 text-center md:px-6 md:pt-24">
        <span className="inline-flex items-center gap-1.5 rounded-full border border-accent-400/50 bg-accent-500/15 px-3 py-1 text-xs tracking-[0.2em] text-accent-200">
          <i className="ri-radio-button-line" />
          实锤 · 内幕 · 深扒 —— 全程持续更新
        </span>

        <p className="mt-5 text-xs tracking-[0.35em] text-background-200/90 md:text-sm">
          九色黑料 · 专题合集归档站
        </p>

        <h2 className="font-heading mt-3 text-3xl font-black leading-tight text-background-50 md:text-5xl">
          把九色黑料的实锤与内幕
          <br className="md:hidden" />
          <span className="text-accent-300"> 按顺序一条条理清楚</span>
        </h2>

        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
          深扒不靠猜，细节讲究前后对位。这里把九色黑料实锤、内幕与证据按事件先后归档，
          想查证的人顺着索引往下走，就能找到对应细节，少走弯路。
        </p>

        <div className="mt-7 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#collections"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 hover:bg-primary-400"
          >
            <i className="ri-folder-open-line mr-1" />
            浏览专题合集
          </a>
          <a
            href="#timeline"
            className="whitespace-nowrap rounded-md border border-background-200/40 bg-background-50/5 px-6 py-3 text-sm font-medium text-background-100 hover:bg-background-50/15"
          >
            <i className="ri-node-tree mr-1" />
            查看深扒顺序
          </a>
        </div>

        <p className="mt-4 inline-flex items-center gap-2 text-xs text-background-300">
          <i className="ri-refresh-line text-accent-300" />
          最近更新：人物档案 041 · 刚刚追加新进度
        </p>

        {/* stats */}
        <div className="mt-10 grid w-full grid-cols-2 gap-3 md:grid-cols-4">
          {heroStats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-background-200/25 bg-foreground-950/30 px-4 py-4 text-center backdrop-blur"
            >
              <p className="font-heading text-2xl font-black text-accent-300 md:text-3xl">{s.value}</p>
              <p className="mt-1 text-xs text-background-200/90">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}